<template>
    <div class="form-group">
      <div class="row">
          <div class="col-1">
          </div>
          <div class="col-3">
            <label>Stato</label>
          </div>
          <div class="col-3">
            <label>Notifica scadenzario</label>
          </div>
          <div class="col-3">
            <label>Cambio stato in data:</label>
          </div>
      </div>
      <div class="row" v-for="alert in deadlines">
          <div class="col-1">
            <a class="btn btn--red" @click="deleteAlert(alert.id)"> <i class="fas fa-trash"></i> </a>
          </div>
          <div class="col-3">
              {{alert.statusName}}
          </div>
          <div class="col-3">
              <input type="checkbox" value="1" v-model="alert.alert_status" @change="updateAlert(alert)">
          </div>
          <div class="col-3">
              <input type="date" v-model="alert.change_status_date" @change="updateAlert(alert)">
          </div>
      </div>

      <hr>
      <div class="row">
          <div class="col-1">
            <a class="btn btn--green" @click="addAlert()"> <i class="fas fa-plus"></i> </a>
          </div>
          <div class="col-3">
            <label>Stato</label>
            <select class="form-control" v-model="newStatusId">
                <option value="">---</option>
                <option v-for="status in statuses" :value="status.id" >
                    {{status.identifable_name}}
                </option>
            </select>
          </div>
          <div class="col-3">
            <label>Notifica scadenzario</label>
            <input type="checkbox" value="1" v-model="newAlertStatus">
          </div>
          <div class="col-3">
            <label>Cambio stato in data:</label>
            <input type="date" class="form-control" v-model="newChangeStatus">
          </div>
      </div>
    </div>

</template>

<script>

export default {
  mounted() {
     this.getDeadlines();
    },
    data () {
        return {
          deadlines : [],
          newStatusId : null,
          newAlertStatus : null,
          newChangeStatus : null,
        }
    },
    methods: {

      updateAlert(row){

          let params ={
                updateDeadline : {
                      course_id   : row.course_id,
                      course_status_id   : row.course_status_id,
                      alert_status : row.alert_status,
                      change_status_at : row.change_status_date
                }
            };
          axios.put("/update-course-deadline/"+row.id,params).then((response) => {
            this.getDeadlines();
          }).catch(function(error){
            alert(error);
          });
            
      },
      addAlert(){
        let params ={
          storeDeadline : {
            alert_status : this.newAlertStatus,
            course_status_id : this.newStatusId,
            change_status_at : this.newChangeStatus,
            course_id   : this.course_id
          }
        };

        axios.post("/store-course-deadline",params).then((response) => {
          this.getDeadlines();
        }).catch(function(error){
          alert(error);
        });

      },
      getDeadlines(){

            axios.get("/api/course-deadline/"+this.course_id).then((response) => {
              this.deadlines = response.data;
              console.log("deadlines",this.deadlines);
            }).catch(function(error){
              alert(error);
            });
        },
        deleteAlert(id){

          axios.delete("/delete-course-deadline/"+id).then((response) => {
            this.getDeadlines();
          }).catch(function(error){
            alert(error);
          });
        },
      },

      props: {
          course_id: {
              type: Number,
              required: true
          },
          statuses : {
              type:Array,
              required : true
          }
      }

}
</script>